import React from 'react';
import ProductList2 from './ProductList2';

const Shop: React.FC = () => {
  return (
    <>
      {/* ProductList Component */}
      <ProductList2 />
    </>
  );
};

export default Shop;

